/* product.js
 * Hooks into: the product template rendered by sections/main-product.liquid.
 *   [data-product-form]        the add-to-cart form (falls back to native submit)
 *   [data-product-variant]     <select name="id"> (multi-variant) or hidden input
 *   [data-product-variants]    <script type="application/json"> with per-variant strings
 *   [data-product-price]       price block container (rebuilt on variant change)
 *   [data-product-availability] availability line
 *   [data-product-gallery]     gallery with [data-media-id] items + [data-media-thumb]
 *   [data-sample-button]       order-a-sample button (adds the sample variant)
 *   [data-box-calculator][data-mode=product]  prices updated from the variant
 *   [data-product-message]     polite status region
 * Plain ES2020, no dependencies. Loaded with defer; pages work without JS.
 */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function readVariants() {
    var node = document.querySelector('[data-product-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  }

  function priceHTML(v) {
    var html = '<div class="price" data-price>';
    if (v.unit) {
      html += '<span class="price__unit"><span class="price__amount">' + esc(v.unit) +
        '</span><span class="price__per">/ ' + esc(v.unit_ref || 'sq ft') + '</span></span>';
      html += '<span class="price__box">' + esc(v.box_per || v.box) + ' per box</span>';
    } else {
      html += '<span class="price__amount">' + esc(v.box) + '</span><span class="price__box">per box</span>';
    }
    if (v.was) {
      html += '<span class="price__was"><span class="visually-hidden">Was</span><s>' + esc(v.was) +
        '</s><span class="price__save">' + esc(v.save) + '</span></span>';
    }
    html += '</div>';
    return html;
  }

  function init() {
    var variants = readVariants();
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var form = document.querySelector('[data-product-form]');
    var variantField = document.querySelector('[data-product-variant]');
    var priceBox = document.querySelector('[data-product-price]');
    var availability = document.querySelector('[data-product-availability]');
    var message = document.querySelector('[data-product-message]');

    function setMessage(text, isError) {
      if (!message) return;
      message.textContent = text;
      message.classList.toggle('is-error', !!isError);
    }

    /* ---------- gallery ---------- */
    var gallery = document.querySelector('[data-product-gallery]');
    function activateMedia(id) {
      if (!gallery || !id) return;
      gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === String(id));
      });
      gallery.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
        var on = thumb.getAttribute('data-media-thumb') === String(id);
        thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
        thumb.classList.toggle('is-active', on);
      });
    }
    if (gallery) {
      gallery.classList.add('is-enhanced');
      var first = gallery.querySelector('[data-media-id]');
      if (first) activateMedia(first.getAttribute('data-media-id'));
      gallery.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          activateMedia(thumb.getAttribute('data-media-thumb'));
        });
      });
    }

    /* ---------- variant change ---------- */
    if (variantField && priceBox) {
      variantField.addEventListener('change', function () {
        var v = byId[String(variantField.value)];
        if (!v) return;
        priceBox.innerHTML = priceHTML(v);
        if (availability && v.availability) availability.textContent = v.availability;
        if (form) {
          var addBtn = form.querySelector('[data-product-add]');
          if (addBtn) addBtn.disabled = !v.available;
        }
        if (v.unit) {
          var calc = document.querySelector('[data-box-calculator][data-mode="product"]');
          if (calc) calc.setAttribute('data-price-per-box', String(v.price_cents || ''));
          if (v.coverage) {
            var covInput = calc && calc.querySelector('[data-coverage-input]');
            if (covInput) covInput.value = v.coverage;
            if (calc) calc.setAttribute('data-coverage', v.coverage);
          }
        }
        if (v.featured_media_id) activateMedia(v.featured_media_id);
        var skuCell = document.querySelector('[data-spec="sku"]');
        if (skuCell) skuCell.textContent = v.sku || '';
        var colourCell = document.querySelector('[data-spec="colour"]');
        if (colourCell && v.colour) colourCell.textContent = v.colour;
        if (v.url && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', v.url);
        }
      });
    }

    /* ---------- add to cart (progressive enhancement) ---------- */
    var addUrl = '/cart/add';
    if (form) {
      addUrl = form.getAttribute('action') || addUrl;
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) return; /* native submit */
        event.preventDefault();
        var btn = form.querySelector('[data-product-add]');
        if (btn) btn.disabled = true;
        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().catch(function () { return {}; }).then(function (body) { return { ok: res.ok, body: body }; }); })
          .then(function (result) {
            if (!result.ok) {
              setMessage((result.body && result.body.description) || 'Sorry, that did not go through. Please try again.', true);
              if (btn) btn.disabled = false;
              return;
            }
            if (window.NexoraCart) window.NexoraCart.refresh();
            setMessage('Added to your cart.', false);
            if (btn) btn.disabled = false;
          })
          .catch(function () {
            setMessage('Sorry, that did not go through. Please try again.', true);
            if (btn) btn.disabled = false;
          });
      });
    }

    /* ---------- sample button ---------- */
    var sample = document.querySelector('[data-sample-button]');
    if (sample) {
      sample.addEventListener('click', function () {
        var id = sample.getAttribute('data-sample-variant-id');
        if (!id || !window.fetch) return;
        sample.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
          .then(function (result) {
            if (result.ok) {
              if (window.NexoraCart) window.NexoraCart.refresh();
              setMessage('Sample added to your cart.', false);
            } else {
              setMessage((result.body && result.body.description) || 'Could not add the sample.', true);
            }
            sample.disabled = false;
          })
          .catch(function () {
            setMessage('Could not add the sample.', true);
            sample.disabled = false;
          });
      });
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();